// EAA-1667: Screen-access rule shape + matcher, moved from web-content's
// config/screenPermissions.ts into packages/hooks. This is pure, app-agnostic
// routing logic (a path-prefix → required-permissions map); the concrete rule
// *data* (SCREEN_ROUTE_RULES) and permission *codes* stay app-side and are passed
// in, so any app can reuse the matcher with its own route table.

/** One screen-access rule: any of `anyOf` permissions grants access to `pathPrefix`. */
export interface ScreenRouteRule {
    pathPrefix: string;
    anyOf: readonly string[];
}

/**
 * Find the rule governing `pathname` — an exact match on `pathPrefix` or a
 * `${pathPrefix}/…` descendant. Returns `undefined` when no rule applies (caller
 * decides whether an unruled path is open or closed).
 */
export function findScreenRuleForPath(
    rules: readonly ScreenRouteRule[],
    pathname: string
): ScreenRouteRule | undefined {
    return rules.find(
        (rule) => pathname === rule.pathPrefix || pathname.startsWith(`${rule.pathPrefix}/`)
    );
}
